import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'noHashedId',
      component: () => import('./views/404.vue'),
    },
    {
      path: '/:hashedId',
      redirect: '/projectteam/:hashedId',
    },
    {
      path: '/projectteam/:hashedId',
      name: 'Projectteam',
      component: () => import('./views/Projectteam.vue'),
    },
    {
      path: '/rex-o-matic/:hashedId',
      name: 'RexOMatic',
      component: () => import('./views/RexOMatic.vue'),
    },
    {
      path: '/billing/:hashedId',
      name: 'Billing',
      component: () => import('./views/Billing.vue'),
    },
    {
      path: '/systemname/:hashedId',
      name: 'Systemname',
      component: () => import('./views/Systemname.vue'),
    },
    {
      path: '/departments/:hashedId',
      name: 'Departments',
      component: () => import('./views/Departments.vue'),
    },
    {
      path: '/hour-types/:hashedId',
      name: 'HourTypes',
      component: () => import('./views/HourTypes.vue'),
    },
    {
      path: '/allowances/:hashedId',
      name: 'Allowances',
      component: () => import('./views/Allowances.vue'),
    },
    {
      path: '/leave/:hashedId',
      name: 'Leave',
      component: () => import('./views/Leave.vue'),
    },
    {
      path: '/contracts/:hashedId',
      name: 'Contracts',
      component: () => import('./views/Contracts.vue'),
    },
    {
      path: '/overtime/:hashedId',
      name: 'Overtime',
      component: () => import('./views/Overtime.vue'),
    },
    {
      path: '/break-settings/:hashedId',
      name: 'BreakSettings',
      component: () => import('./views/BreakSettings.vue'),
    },
    {
      path: '/rounding-settings/:hashedId',
      name: 'RoundingSettings',
      component: () => import('./views/RoundingSettings.vue'),
    },
    {
      path: '/employee-settings/:hashedId',
      name: 'EmployeeSettings',
      component: () => import('./views/EmployeeSettings.vue'),
    },
    {
      path: '/sign/:hashedId',
      name: 'Sign',
      props: true,
      component: () => import('./views/Sign.vue'),
    },
  ],
});
